export default [
    {
        path: '/roles',
        name: 'roles',
        component: () => import('../../pages/roles/IndexPage.vue'),
        meta: {
            title: 'Roles',
            requiresAuth: true,
        },
    },
    {
        path: '/roles/:id',
        name: 'roles-detail',
        component: () => import('../../pages/roles/IndexPage.vue'),
        meta: {
            title: 'Role Detail',
            requiresAuth: true,
        },
    },
]
